import React from 'react';
import { RegisterConfigPage } from './RegisterConfigPage';

export const ThreatConfigPage: React.FC = () => {
  return <RegisterConfigPage kind="threat" />;
};
